module.exports = __webpack_public_path__ + "img/recruiterView-selected.9b86e348.svg";